import * as React from 'react';
import type { PageProps } from 'gatsby';

export function useSearchParams(location: PageProps['location'] | null) {
  return React.useMemo(() => {
    return new URLSearchParams(location?.search);
  }, [location?.search]);
}
